import loadSessionModule from './modules/Session.module';
import loadAuthenticationModule from './modules/Authentication.module';
const loadAccountMenuModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule(), loadAuthenticationModule()],
});
export default loadAccountMenuModule;
